  import {RequestLineItemModel} from './index';
  export class RequestCartModel {
    lineItems: RequestLineItemModel[];
}
